// import React, { useState, useEffect, useContext } from 'react';
// import { EventContext } from '../context/EventContext';
// import { Group } from '../types/Group';
// import { getGroupsByEventId, createGroup, updateGroup, removeGroup } from '../services/groupService';
// import { AssignmentDetails } from '../types/Assignment';
// import { getAllAssignmentsByEventId } from '../services/assignmentService';
// import GroupAssignmentDetailsTable from './GroupAssignmentDetailsTable';
// import { useToast } from '../context/ToastContext';
// import ToggleSwitch from './ToggleSwitch';

// interface GroupDashboardProps {
//     itemsPerPage?: number;
// }

// const GroupDashboard: React.FC<GroupDashboardProps> = ({ itemsPerPage = 10 }) => {
//     const { currentEvent } = useContext(EventContext);
//     const [groups, setGroups] = useState<Group[]>([]);
//     const [filteredGroups, setFilteredGroups] = useState<Group[]>([]);
//     const [currentGroup, setCurrentGroup] = useState<Group | null>(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [editGroup, setEditGroup] = useState<Group | null>(null);
//     const [isEditing, setIsEditing] = useState(false);
//     const [isCreating, setIsCreating] = useState(false);
//     const [assignments, setAssignments] = useState<AssignmentDetails[]>([]);
//     const [showDeletedGroups, setShowDeletedGroups] = useState(false);

//     const { addToast } = useToast();

//     // Fetch groups for the current event
//     useEffect(() => {
//         const fetchGroups = async () => {
//             if (currentEvent) {
//                 const eventGroups = await getGroupsByEventId(currentEvent.event_id);
//                 setGroups(eventGroups);

//                 setFilteredGroups(
//                     showDeletedGroups ? eventGroups : eventGroups.filter(group => !group.is_deleted)
//                 );
//             }
//         };

//         const fetchAssignments = async () => {
//             if (currentEvent) {
//                 const assignmentList = await getAllAssignmentsByEventId(currentEvent.event_id, currentEvent.event_type_id === 'MUSIC');
//                 setAssignments(assignmentList);
//             }
//         };
//         fetchGroups();
//         fetchAssignments();
//     }, [currentEvent, showDeletedGroups]);



//     // Handle search functionality
//     useEffect(() => {
//         if (searchQuery) {
//             setFilteredGroups(
//                 groups
//                     .filter(group => !group.is_deleted || showDeletedGroups) // Check is_deleted condition
//                     .filter(group =>
//                         group.group_name.toLowerCase().includes(searchQuery.toLowerCase())
//                     )
//             );
//         } else {
//             setFilteredGroups(
//                 showDeletedGroups
//                     ? groups
//                     : groups.filter(group => !group.is_deleted)
//             );
//         }
//     }, [searchQuery, groups, showDeletedGroups]);

//     // Handle group editing
//     const handleEdit = (group: Group) => {
//         setEditGroup(group);
//         setIsEditing(true);
//     };

//     // Handle group creation
//     const handleCreate = () => {
//         if (currentEvent) {
//             setEditGroup({
//                 event_group_id: '',
//                 group_name: '',
//                 level: groups.length + 1,
//                 is_deleted: false,
//                 event_id: currentEvent?.event_id,
//             });
//             setIsCreating(true);
//             setIsEditing(true);
//         }
//     };

//     // Save group changes (create or update)
//     const handleSaveEdit = async () => {
//         if (!editGroup?.group_name) {
//             return;
//         }
//         if (editGroup) {
//             if (isCreating) {
//                 // Call createGroup function
//                 try {
//                     if (currentEvent && editGroup) {
//                         const newGroup = await createGroup(editGroup);
//                         if (newGroup) {
//                             setGroups([...groups, newGroup]);
//                             setFilteredGroups([...groups, newGroup]);
//                             addToast('Group created.');

//                         }
//                     }
//                 } catch (error) {
//                     addToast('Error creating group.', true);
//                     console.error('Error creating group:', error);
//                 }
//                 setIsCreating(false);
//             } else {
//                 // Call updateGroup function
//                 try {
//                     const updatedGroup = await updateGroup(editGroup.event_group_id, editGroup);
//                     const updatedGroups = groups.map((group) =>
//                         group.event_group_id === updatedGroup?.event_group_id ? editGroup : group
//                     );
//                     setGroups(updatedGroups);
//                     setFilteredGroups(updatedGroups);
//                     addToast('Group updated.');

//                 } catch (error) {
//                     addToast('Error updating group.', true);
//                     console.error('Error updating group:', error);
//                 }
//             }
//             setIsEditing(false);
//         }
//     };

//     // Handle group deletion
//     const handleDelete = async () => {
//         if (editGroup) {
//             try {
//                 await removeGroup(editGroup.event_group_id);
//                 const updatedGroups = groups.filter(
//                     (group) => group.event_group_id !== editGroup.event_group_id
//                 );
//                 setGroups(updatedGroups);
//                 setFilteredGroups(updatedGroups);
//                 setIsEditing(false);
//                 setIsCreating(false);
//             } catch (error) {
//                 console.error('Error deleting group:', error);
//             }
//         }
//     };

//     return (
//         <div style={{ padding: '20px' }}>
//             {/* Current Group Name */}
//             <h1>{`${currentEvent?.event_name} ${currentEvent?.event_type_group_name_plural ?? 'Groups'}`} </h1>
//             <h2 style={{ marginBottom: '20px' }}>{currentGroup ? `Current Group: ${currentGroup.group_name}` : `Select a ${currentEvent?.event_type_description}`}</h2>

//             {/* Search Bar */}
//             <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
//                 <input
//                     type="text"
//                     placeholder={`Search ${currentEvent?.event_type_group_name_plural}...`}
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 <ToggleSwitch
//                     label={`Show Deleted ${currentEvent?.event_type_group_name_plural ?? ''}`}
//                     checked={showDeletedGroups}
//                     onChange={setShowDeletedGroups}
//                 />
//             </div>

//             {/* Group List */}
//             <div className='card'
//                 style={{
//                     display: 'flex',
//                     flexWrap: 'wrap', // Allow wrapping of group items to the next line
//                     gap: '10px',
//                     padding: '10px',
//                     border: '1px solid #ccc',
//                     borderRadius: '5px',
//                     backgroundColor: '#2c3e50'
//                 }}
//             >
//                 {filteredGroups.map((group) => (
//                     <div
//                         key={group.event_group_id}
//                         className="card"
//                         style={{
//                             flex: '0 0 auto',
//                             padding: '20px',
//                             border: currentGroup?.event_group_id === group.event_group_id ? '2px solid green' : '1px solid #ccc',
//                             borderRadius: '5px',
//                             width: '200px', // Ensures each group takes up at least 200px
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             position: 'relative',
//                             backgroundColor: 'white' // For the marker
//                         }}
//                         onClick={() => {
//                             if (currentGroup?.event_group_id == group.event_group_id) {
//                                 setCurrentGroup(null)
//                             } else {
//                                 setCurrentGroup(group);
//                             }
//                         }}
//                     >
//                         <h3>{group.group_name}{group.is_deleted ? ' Deleted' : ''}</h3>
//                         {currentGroup?.event_group_id === group.event_group_id && (
//                             <span
//                                 style={{
//                                     position: 'absolute',
//                                     top: '5px',
//                                     right: '10px',
//                                     fontStyle: 'italic',
//                                     color: 'green',
//                                 }}
//                             >
//                                 Selected
//                             </span>
//                         )}
//                         <p>Level {group.level}</p>
//                         <button

//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleEdit(group);
//                             }}
//                         >
//                             Edit
//                         </button>
//                     </div>
//                 ))}

//                 {/* Create Group Button */}
//                 <div
//                     className="card"
//                     style={{
//                         border: '1px dashed #ccc',
//                         minWidth: '200px',
//                         textAlign: 'center',
//                         backgroundColor: 'white'
//                     }}
//                     onClick={handleCreate}
//                 >
//                     <h3>Create {currentEvent?.event_type_group_name_plural}</h3>
//                     <h1>+</h1>
//                 </div>
//             </div>

//             {/* Edit Group Popup */}
//             {isEditing && editGroup && (
//                 <div
//                     style={{
//                         position: 'fixed',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         background: 'white',
//                         padding: '20px',
//                         border: '1px solid #ccc',
//                         borderRadius: '5px',
//                         zIndex: 1000,
//                     }}
//                 >
//                     <h3>{isCreating ? `Create ${currentEvent?.event_type_group_name}` : `Edit ${currentEvent?.event_type_group_name}`}</h3>
//                     <div style={{ marginBottom: '10px' }}>
//                         <label>{currentEvent?.event_type_group_name} Name:</label>
//                         <input
//                             type="text"
//                             value={editGroup.group_name}
//                             onChange={(e) =>
//                                 setEditGroup({ ...editGroup, group_name: e.target.value })
//                             }
//                         />
//                     </div>
//                     <div style={{ marginBottom: '10px' }}>
//                         <label>{currentEvent?.event_type_group_name} Level:</label>
//                         <input
//                             type="number"
//                             value={editGroup.level}
//                             onChange={(e) =>
//                                 setEditGroup({ ...editGroup, level: parseInt(e.target.value) })
//                             }
//                             min={1}
//                             max={groups.length + (isCreating ? 1 : 0)}

//                         />
//                     </div>
//                     <button onClick={handleSaveEdit} style={{ marginRight: '10px' }} disabled={editGroup.group_name == ''}>
//                         Save
//                     </button>
//                     <button className='cancelButton'
//                         style={{
//                             marginRight: '150px',
//                         }}
//                         onClick={() => {
//                             setIsEditing(false);
//                             setIsCreating(false);
//                         }}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         style={{
//                             background: '#dc3545',
//                         }}
//                         onClick={handleDelete}
//                     >
//                         Delete
//                     </button>
//                 </div>
//             )}

//             {/* Backdrop for Popup */}
//             {isEditing && (
//                 <div
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         background: 'rgba(0, 0, 0, 0.5)',
//                         zIndex: 999,
//                     }}
//                     onClick={() => {
//                         setIsEditing(false);
//                         setIsCreating(false);
//                     }}
//                 />
//             )}

//             <GroupAssignmentDetailsTable
//                 assignments={assignments}
//                 group_id={currentGroup?.event_group_id || null}
//                 is_music={currentEvent?.event_type_id === 'MUSIC'}
//             />
//         </div>
//     );
// };

// export default GroupDashboard;

import React, { useState, useEffect, useContext } from 'react';
import { EventContext } from '../context/EventContext';
import { Group } from '../types/Group';
import { AssignmentWithEvaluation, AssignmentDetails, Assignment } from '../types/Assignment';
import { getGroupsByEventId, createGroup, updateGroup, removeGroup } from '../services/groupService';
import { getAllAssignmentsByEventId, getAllAssignmentsByEventIdandInstrument, postAssignments, removeAssignment } from '../services/assignmentService';
import { getEventInstruments } from '../services/eventInstrumentService';
import { getEvaluationsByEventId } from '../services/evaluationService';
import GroupAssignmentDetailsTable from './GroupAssignmentDetailsTable';
import { useToast } from '../context/ToastContext';
import ToggleSwitch from './ToggleSwitch';
import SimpleInstrumentDropdown from './SimpleInstrumentDropdown';
import { Evaluation } from '../types/Scorecard';
import { EventInstrument } from '../types/Instrument';


const GroupDashboard: React.FC = () => {
    const { currentEvent } = useContext(EventContext);
    const [groups, setGroups] = useState<Group[]>([]);
    const [assignments, setAssignments] = useState<AssignmentWithEvaluation[]>([]);
    // const [unsortedAssignments, setUnsortedAssignments] = useState<AssignmentWithEvaluation[]>([]);
    const [currentInstrument, setCurrentInstrument] = useState<EventInstrument>();
    const [instruments, setInstruments] = useState<any[]>([]);
    const [filteredGroups, setFilteredGroups] = useState<Group[]>([]);
    const [currentGroup, setCurrentGroup] = useState<Group | null>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editGroup, setEditGroup] = useState<Group | null>(null);
    const [groupBandQuery, setGroupBandQuery] = useState('');
    const [showDeletedGroups, setShowDeletedGroups] = useState(false);
    const { addToast } = useToast();
    const [filteredAssignments, setFilteredAssignments] = useState<AssignmentWithEvaluation[]>(assignments);
    const [searchAssignmentQuery, setAssignmentSearchQuery] = useState('');
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'asc' | 'desc' }>({ key: 'first_name', direction: 'asc' });

    // Fetching groups and assignments
    useEffect(() => {
        const fetchAndCombineData = async () => {
            if (!currentEvent) return;

            try {
                const [assignmentData, evaluationData] = await Promise.all([
                    fetchAssignments(),
                    fetchEvaluations(),
                ]);

                const evaluationsByRegistrant = evaluationData.reduce(
                    (acc: Record<string, Evaluation[]>, evaluation: Evaluation) => {
                        if (!acc[evaluation.registrant_id]) {
                            acc[evaluation.registrant_id] = [];
                        }
                        acc[evaluation.registrant_id].push(evaluation);
                        return acc;
                    },
                    {}
                );

                const combinedData = assignmentData.map((assignment) => {
                    const evaluations = evaluationsByRegistrant[assignment.registrant_id] || [];

                    // Group evaluations by judge_id for the assignment
                    const evaluationsByJudge = evaluations.reduce(
                        (judgeMap: Record<string, Evaluation[]>, evaluation) => {
                            if (!judgeMap[evaluation.judge_id]) {
                                judgeMap[evaluation.judge_id] = [];
                            }
                            judgeMap[evaluation.judge_id].push(evaluation);
                            return judgeMap;
                        },
                        {}
                    );

                    // Get the most recent evaluation score from each judge
                    const recentScores = Object.values(evaluationsByJudge).map((judgeEvals) =>
                        judgeEvals
                            .sort((a, b) => new Date(b.created_at!).getTime() - new Date(a.created_at!).getTime())[0]
                            .total_score
                    );

                    // Parse scores and calculate the average
                    const recentScoresNumbers = recentScores.map((score) => parseFloat(score.toString()));
                    const averageScore =
                        (recentScoresNumbers.reduce((sum, score) => sum + score, 0) / recentScoresNumbers.length) || 0;

                    return {
                        ...assignment,
                        evaluations,
                        average_score: averageScore, // Add average_score to assignment
                    };
                });

                setAssignments(combinedData);

            } catch (error) {
                console.error('Error fetching and combining data:', error);
            }
        };
        const fetchGroups = async () => {
            if (currentEvent) {
                const eventGroups = await getGroupsByEventId(currentEvent.event_id);
                const unassignedGroup: Group = { event_group_id: 'unassigned', group_name: 'Unassigned', level: 0, is_deleted: false, event_id: currentEvent.event_id }
                setGroups([unassignedGroup, ...eventGroups]);
                setFilteredGroups(showDeletedGroups ? eventGroups : eventGroups.filter(group => !group.is_deleted));
            }
        };

        const fetchAssignments = async (): Promise<AssignmentDetails[]> => {
            if (currentEvent) {
                const assignmentList = await getAllAssignmentsByEventId(currentEvent.event_id, currentEvent.event_type_id === 'MUSIC');
                return assignmentList;
                //setAssignments(assignmentList);
                //const unsortedList = assignmentList.filter(assignment => !assignment.event_group_id);
            } else {
                return [];
            }
        };

        const fetchEvaluations = async (): Promise<Evaluation[]> => {
            if (!currentEvent) return [];
            return await getEvaluationsByEventId(currentEvent.event_id);
        };

        const fetchInstruments = async () => {
            if (currentEvent) {
                const instrumentData = await getEventInstruments(currentEvent.event_id);
                setInstruments(instrumentData);
            }
        };
        fetchAndCombineData();
        fetchGroups();
        //fetchAssignments();
        fetchInstruments();
    }, [currentEvent, showDeletedGroups]);

    // Handle Search
    useEffect(() => {
        if (groupBandQuery) {
            setFilteredGroups(groups.filter(group => group.group_name.toLowerCase().includes(groupBandQuery.toLowerCase())));
        } else {
            setFilteredGroups(showDeletedGroups ? groups : groups.filter(group => !group.is_deleted));
        }
    }, [groupBandQuery, groups, showDeletedGroups]);

    // Handle Drag and Drop
    const handleDrop = (assignmentId: string, targetGroupId: string) => {
        setAssignments(prev => {
            const assignmentToMove = prev.find(a => a.assignment_id === assignmentId);
            if (!assignmentToMove) return prev;

            assignmentToMove.event_group_id = targetGroupId;
            const updatedAssignments = prev.filter(a => a.assignment_id !== assignmentId).concat(assignmentToMove);
            return updatedAssignments;
        });

        // setUnsortedAssignments(prev => prev.filter(a => a.assignment_id !== assignmentId));
    };

    const handleSwitchGroups = async (registrantId: string, targetGroupId: string) => {
        if (!currentEvent) return;

        const isMusic = currentEvent.event_type_id === 'MUSIC';
        const updated = [...assignments]; // use the current state value

        const movedIndex = updated.findIndex(a => a.registrant_id === registrantId);
        if (movedIndex === -1) return;

        const movedAssignment = updated[movedIndex];
        const previousGroupId = movedAssignment.event_group_id;

        // Recalculate chair numbers in previous group
        const previousGroupAssignments = updated
            .filter(a => a.event_group_id === previousGroupId)
            .filter(a => isMusic ? a.instrument_id === movedAssignment.instrument_id : true)
            .filter(a => a.registrant_id !== registrantId)
            .sort((a, b) => (a.chair_number ?? 0) - (b.chair_number ?? 0))
            .map((a, index) => ({
                ...a,
                chair_number: index + 1
            }));

        // Determine chair number in the target group
        const targetGroupAssignments = updated
            .filter(a => a.event_group_id === targetGroupId)
            .filter(a => isMusic ? a.instrument_id === movedAssignment.instrument_id : true);

        const newChairNumber = targetGroupAssignments.length + 1;

        // Update the moved assignment
        const updatedMoved = {
            ...movedAssignment,
            event_group_id: targetGroupId,
            chair_number: newChairNumber,
        };

        // Combine all assignments and deduplicate by registrant_id
        const combinedAssignments = [
            ...updated.filter(a => a.registrant_id !== registrantId), // remove old
            ...previousGroupAssignments,
            updatedMoved
        ];

        const dedupedMap = new Map<string, Assignment>();
        for (const assignment of combinedAssignments) {
            dedupedMap.set(assignment.registrant_id, assignment); // Last one wins
        }

        const finalAssignments = Array.from(dedupedMap.values());

        // Set updated state
        setAssignments(finalAssignments as AssignmentWithEvaluation[]);

        // Update DB
        const targetGroup = finalAssignments.filter(a => a.event_group_id === targetGroupId);
        const formattedTargetGroup = targetGroup.map(formatAssignment);
        await postAssignments(formattedTargetGroup);

        if (previousGroupId && previousGroupId !== targetGroupId) {
            const originalGroup = finalAssignments.filter(a => a.event_group_id === previousGroupId);
            const formattedOriginalGroup = originalGroup.map(formatAssignment);
            await postAssignments(formattedOriginalGroup);
        }
    };

    function formatAssignment(assignment: Assignment): Assignment {
        return {
            assignment_id: assignment.assignment_id,
            event_group_id: assignment.event_group_id,
            registrant_id: assignment.registrant_id,
            chair_number: assignment.chair_number,
            group_role: assignment.group_role,
        };
    }

    // const handleSendGroupAssignments = async (group_id: string) => {
    //     if (group_id == 'unassigned' || group_id == null) {
    //         return true;
    //     }
    //     const groupAssignments = assignments.filter(
    //         (assignment) => assignment.event_group_id === group_id
    //     );

    //     console.log("help", assignments, groupAssignments);

    //     // Ensure assignments conform to AssignmentDetails type
    //     const formattedAssignments: Assignment[] = groupAssignments.map((assignment) => ({
    //         assignment_id: assignment.assignment_id,
    //         event_group_id: assignment.event_group_id,
    //         registrant_id: assignment.registrant_id,
    //         chair_number: assignment.chair_number,
    //         group_role: assignment.group_role,
    //         organization_name: assignment.organization_name,
    //     }));
    //     console.log(formattedAssignments, group_id);

    //     return await postAssignments(formattedAssignments);
    // };

    const moveUp = async (assignment: AssignmentWithEvaluation) => {
        if (!currentEvent) {
            addToast('No event!', true);
            return;
        }
        if (!assignment.registrant_id) {
            addToast('No registrant_id! Please refresh the page.', true);
            return;
        }

        const isMusic = currentEvent.event_type_id === 'MUSIC';

        const originalGroup = assignments.filter(
            a =>
                a.event_group_id === assignment.event_group_id &&
                (!isMusic || a.instrument_id === assignment.instrument_id)
        );

        const normalizedGroup = normalizeChairNumbers(originalGroup);

        const index = normalizedGroup.findIndex(
            a => a.registrant_id === assignment.registrant_id
        );

        if (index <= 0) return;

        const updatedGroup = [...normalizedGroup];
        const current = updatedGroup[index];
        const above = updatedGroup[index - 1];

        const currentNew = { ...current, chair_number: above.chair_number };
        const aboveNew = { ...above, chair_number: current.chair_number };

        const changed = [currentNew, aboveNew];

        const formattedForAPI = changed.map((a): Assignment => ({
            assignment_id: a.assignment_id,
            event_group_id: a.event_group_id,
            registrant_id: a.registrant_id,
            chair_number: a.chair_number,
            group_role: a.group_role,
        }));

        try {
            const success = await postAssignments(formattedForAPI);
            if (success) {
                setAssignments(prev =>
                    prev.map(a => {
                        const updated = changed.find(u => u.registrant_id === a.registrant_id);
                        return updated ? updated : a;
                    })
                );
            } else {
                addToast('Error updating assignment', true);
            }
        } catch (error) {
            addToast('Error updating assignment', true);
            console.error('Failed to update chair numbers:', error);
        }
    };


    const moveDown = async (assignment: AssignmentWithEvaluation) => {
        if (!currentEvent) {
            addToast('No event!', true);
            return;
        }
        if (!assignment.registrant_id) {
            addToast('No registrant_id! Please refresh the page.', true);
            return;
        }

        const isMusic = currentEvent.event_type_id === 'MUSIC';

        const originalGroup = assignments.filter(
            a =>
                a.event_group_id === assignment.event_group_id &&
                (!isMusic || a.instrument_id === assignment.instrument_id)
        );

        const normalizedGroup = normalizeChairNumbers(originalGroup);

        const index = normalizedGroup.findIndex(
            a => a.registrant_id === assignment.registrant_id
        );

        if (index === -1 || index >= normalizedGroup.length - 1) return;

        const updatedGroup = [...normalizedGroup];
        const current = updatedGroup[index];
        const below = updatedGroup[index + 1];

        const currentNew = { ...current, chair_number: below.chair_number };
        const belowNew = { ...below, chair_number: current.chair_number };

        const changed = [currentNew, belowNew];

        const formattedForAPI = changed.map((a): Assignment => ({
            assignment_id: a.assignment_id,
            event_group_id: a.event_group_id,
            registrant_id: a.registrant_id,
            chair_number: a.chair_number,
            group_role: a.group_role,
        }));

        try {
            const success = await postAssignments(formattedForAPI);
            if (success) {
                setAssignments(prev =>
                    prev.map(a => {
                        const updated = changed.find(u => u.registrant_id === a.registrant_id);
                        return updated ? updated : a;
                    })
                );
            } else {
                addToast('Error updating assignment', true);
            }
        } catch (error) {
            addToast('Error updating assignment', true);
            console.error('Failed to update chair numbers:', error);
        }
    };

    const normalizeChairNumbers = (
        group: AssignmentWithEvaluation[]
    ): AssignmentWithEvaluation[] => {
        return [...group]
            .sort((a, b) => a.chair_number - b.chair_number)
            .map((a, index) => ({
                ...a,
                chair_number: index + 1,
            }));
    };

    // Handle group editing
    const handleEditGroup = (group: Group) => {
        setEditGroup(group);
        setIsEditing(true);
    };

    const autoSort = () => {
    };

    const sendToServer = async () => {
        try {
            // Gather all assignments from groups and unsorted
            const allAssignments = [...assignments];

            // Ensure assignments conform to AssignmentDetails type
            const formattedAssignments: Assignment[] = allAssignments.map((assignment) => ({
                assignment_id: assignment.assignment_id,
                event_group_id: assignment.event_group_id,
                registrant_id: assignment.registrant_id,
                chair_number: assignment.chair_number, // Use the value directly as it's part of AssignmentDetails
                group_role: assignment.group_role, // Use the value directly as it's part of AssignmentDetails
                organization_name: assignment.organization_name || "",
            }));

            // Log the formatted assignments
            console.log("Formatted Assignments to be sent to the server:", formattedAssignments);

            // Post the assignments to the server
            await postAssignments(formattedAssignments);

            console.log("Assignments successfully sent to the server.");
        } catch (error) {
            console.error("Error sending assignments to the server:", error);
        }
    };

    const removeFromGroup = async (registrant_id: string, group_id: string) => {
        if (!registrant_id || !group_id) return;

        const success = await removeAssignment(registrant_id);
        if (!success) {
            addToast('Error removing from group', true);
            return;
        }

        setAssignments(prev => {
            const updated = [...prev];
            const isMusic = currentEvent?.event_type_id === 'MUSIC';

            // Remove the assignment locally
            const removedAssignmentIndex = updated.findIndex(
                a => a.registrant_id === registrant_id && a.event_group_id === group_id
            );

            if (removedAssignmentIndex === -1) return prev;

            const removedAssignment = updated[removedAssignmentIndex];
            updated.splice(removedAssignmentIndex, 1); // remove the item

            // Reorder remaining assignments in the same group
            const reordered = updated
                .filter(a => a.event_group_id === group_id)
                .filter(a => isMusic ? a.instrument_id === removedAssignment.instrument_id : true)
                .sort((a, b) => (a.chair_number ?? 0) - (b.chair_number ?? 0))
                .map((a, index) => ({
                    ...a,
                    chair_number: index + 1,
                }));

            // Apply reordered chair numbers to main list
            const finalAssignments = updated.map(a => {
                const updatedA = reordered.find(r => r.registrant_id === a.registrant_id);
                return updatedA ? updatedA : a;
            });


            // Send reordered group to server
            setTimeout(async () => {
                const formattedGroup = reordered.map(({ assignment_id, event_group_id, registrant_id, chair_number, group_role, organization_name }) => ({
                    assignment_id,
                    event_group_id,
                    registrant_id,
                    chair_number,
                    group_role,
                    organization_name,
                }));

                await postAssignments(formattedGroup);
            }, 0);

            return finalAssignments;
        });
    };


    // Handle group creation
    const handleCreateGroup = () => {
        if (currentEvent) {
            setEditGroup({
                event_group_id: '',
                group_name: '',
                level: groups.filter(g => !g.is_deleted).length,
                is_deleted: false,
                event_id: currentEvent?.event_id,
            });
            setIsEditing(true);
        }
    };

    // Save group changes (create or update)
    const handleSaveGroup = async () => {
        if (!editGroup?.group_name) {
            return;
        }
        try {
            if (editGroup.event_group_id) {
                // Update existing group
                const updatedGroup = await updateGroup(editGroup.event_group_id, editGroup);
                if (updatedGroup) {
                    setGroups(
                        groups
                            .map(g => (g.event_group_id === updatedGroup.event_group_id ? updatedGroup : g))
                            .filter((g): g is Group => g !== null)
                    );
                    addToast('Group updated.');
                } else {
                    addToast('Failed to update group.', true);
                }
            } else {
                // Create new group
                const newGroup = await createGroup(editGroup);
                if (newGroup) {
                    setGroups([...groups, newGroup]);
                    addToast('Group created.');
                } else {
                    addToast('Failed to create group.', true);
                }
            }
            setIsEditing(false);
        } catch (error) {
            addToast('Error saving group.', true);
        }

    };

    // Handle group deletion
    const handleDeleteGroup = async () => {
        if (editGroup) {
            try {
                await removeGroup(editGroup.event_group_id);
                setGroups(groups.filter(group => group.event_group_id !== editGroup.event_group_id));
                setIsEditing(false);
                addToast('Group deleted.');
            } catch (error) {
                addToast('Error deleting group.', true);
            }
        }
    };

    useEffect(() => {
        // console.log(assignments);

        const filtered = assignments
            .filter((assignment) => {
                const matchesSearchQuery =
                    assignment.first_name?.toLowerCase().includes(searchAssignmentQuery.toLowerCase()) ||
                    assignment.last_name?.toLowerCase().includes(searchAssignmentQuery.toLowerCase()) ||
                    assignment.instrument_name?.toLowerCase().includes(searchAssignmentQuery.toLowerCase()) ||
                    assignment.group_role?.toLowerCase().includes(searchAssignmentQuery.toLowerCase()) ||
                    assignment.email?.toLowerCase().includes(searchAssignmentQuery.toLowerCase()) ||
                    assignment.organization_name?.toLowerCase().includes(searchAssignmentQuery.toLowerCase());

                const matchesGroupId = currentGroup?.event_group_id ? (assignment.event_group_id === currentGroup?.event_group_id) : true; // Filter by group_id if provided
                const matchesUnassigned = currentGroup?.event_group_id == 'unassigned' && (assignment.event_group_id == null || assignment.event_group_id == '');
                if (currentInstrument && currentEvent?.event_type_id === 'MUSIC' && assignment.instrument_id != currentInstrument.instrument_id) {
                    return false;
                }
                return matchesSearchQuery && (matchesGroupId || matchesUnassigned);
            })
            .sort((a, b) => {
                const isMusic = currentEvent?.event_type_id === 'MUSIC';

                if (isMusic) {
                    // 1. Sort by instrument_id
                    if (a.instrument_id !== b.instrument_id) {
                        return (a.instrument_id || '').localeCompare(b.instrument_id || '');
                    }
                }

                // 2. Sort by chair_number
                if (a.chair_number !== b.chair_number) {
                    return a.chair_number - b.chair_number;
                }

                // 3. Sort by last_name
                return a.last_name.localeCompare(b.last_name);
            });
        setFilteredAssignments(filtered);
    }, [searchAssignmentQuery, assignments, currentGroup?.event_group_id, currentInstrument]);

    // Sort assignments by column when header is clicked
    const handleSort = (key: string) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });

        const sortedAssignments = [...filteredAssignments].sort((a, b) => {
            if (key === 'chair_number') {
                const aChairNumber = a[key as keyof AssignmentDetails] as number;
                const bChairNumber = b[key as keyof AssignmentDetails] as number;
                return direction === 'asc' ? aChairNumber - bChairNumber : bChairNumber - aChairNumber;
            }
            if (key === 'average_score') {
                const scorea = a.average_score as number;
                const scoreb = b.average_score as number;
                return direction === 'asc' ? scorea - scoreb : scoreb - scorea;
            }
            if (key === 'first_name' || key === 'last_name' || key === 'email' || key === 'organization_name' || key === 'group_role') {
                return direction === 'asc'
                    ? ((a[key as keyof AssignmentDetails] ?? '') as string).localeCompare(b[key as keyof AssignmentDetails] as string)
                    : ((b[key as keyof AssignmentDetails] ?? '') as string).localeCompare(a[key as keyof AssignmentDetails] as string);
            }
            if (key === 'instrument') {
                const ia = a.instrument_name ?? '' as string;
                const ib = b.instrument_name ?? '' as string;
                return direction === 'asc'
                    ? ia.localeCompare(ib)
                    : ib.localeCompare(ia);
            }
            return 0;
        });

        setFilteredAssignments(sortedAssignments);
    };


    const sortAndAssignRegistrants = (
        sortType: 'random' | 'score-roundrobin',
        isMusic: boolean,
        currentInstrumentId?: string
    ): AssignmentWithEvaluation[] => {
        // Step 1: Filter unassigned
        let unassigned = assignments.filter(
            a =>
                (!a.event_group_id || a.event_group_id === '' || a.event_group_id === 'unassigned') &&
                (!currentInstrumentId || a.instrument_id === currentInstrumentId)
        );

        const targetGroups = groups.filter(g => g.event_group_id !== 'unassigned');
        const groupCount = targetGroups.length;

        let groupAssignments: AssignmentWithEvaluation[] = [];

        if (sortType === 'random') {
            if (isMusic) {
                // Group by instrument
                const instrumentMap: Record<string, AssignmentWithEvaluation[]> = {};
                for (const r of unassigned) {
                    const key = r.instrument_id || 'default';
                    if (!instrumentMap[key]) instrumentMap[key] = [];
                    instrumentMap[key].push(r);
                }

                // Shuffle each instrument and round-robin assign
                for (const instrumentId in instrumentMap) {
                    const shuffled = instrumentMap[instrumentId].sort(() => Math.random() - 0.5);
                    shuffled.forEach((registrant, idx) => {
                        const group = targetGroups[idx % groupCount];
                        groupAssignments.push({
                            ...registrant,
                            event_group_id: group.event_group_id,
                            chair_number: getChairNumber(assignments.concat(groupAssignments), group.event_group_id, instrumentId) + 1
                        });
                    });
                }

            } else {
                // Non-music random: just shuffle and assign
                const shuffled = unassigned.sort(() => Math.random() - 0.5);
                shuffled.forEach((registrant, idx) => {
                    const group = targetGroups[idx % groupCount];
                    groupAssignments.push({
                        ...registrant,
                        event_group_id: group.event_group_id,
                        chair_number: getChairNumber(assignments.concat(groupAssignments), group.event_group_id) + 1
                    });
                });
            }

        } else if (sortType === 'score-roundrobin') {
            unassigned.sort((a, b) => (b.average_score ?? 0) - (a.average_score ?? 0));

            if (isMusic) {
                // Group by instrument
                const instrumentMap: Record<string, AssignmentWithEvaluation[]> = {};
                for (const r of unassigned) {
                    const key = r.instrument_id || 'default';
                    if (!instrumentMap[key]) instrumentMap[key] = [];
                    instrumentMap[key].push(r);
                }

                for (const instrumentId in instrumentMap) {
                    const instrumentRegistrants = instrumentMap[instrumentId];
                    instrumentRegistrants.forEach((registrant, idx) => {
                        const group = targetGroups[idx % groupCount];
                        groupAssignments.push({
                            ...registrant,
                            event_group_id: group.event_group_id,
                            chair_number: getChairNumber(assignments.concat(groupAssignments), group.event_group_id, instrumentId) + 1
                        });
                    });
                }

            } else {
                // Non-music: round-robin by score
                unassigned.forEach((registrant, idx) => {
                    const group = targetGroups[idx % groupCount];
                    groupAssignments.push({
                        ...registrant,
                        event_group_id: group.event_group_id,
                        chair_number: getChairNumber(assignments.concat(groupAssignments), group.event_group_id) + 1
                    });
                });
            }
        }

        return groupAssignments;
    };

    // Helper function to get next chair number for a group (optionally per instrument)
    function getChairNumber(
        allAssignments: AssignmentWithEvaluation[],
        groupId: string,
        instrumentId?: string
    ): number {
        return allAssignments.filter(a =>
            a.event_group_id === groupId &&
            (!instrumentId || a.instrument_id === instrumentId)
        ).length;
    }
    function chunkArray<T>(array: T[], size: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    }

    async function retryPostAssignments(
        chunk: AssignmentWithEvaluation[],
        maxRetries = 3,
        delayMs = 500
    ): Promise<boolean> {
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            const success = await postAssignments(chunk);
            if (success) return true;

            if (attempt < maxRetries) {
                console.warn(`Batch failed (attempt ${attempt}). Retrying in ${delayMs}ms...`);
                await new Promise(resolve => setTimeout(resolve, delayMs));
            }
        }

        addToast('Failed to update assignments', true);
        console.error(`Batch failed after ${maxRetries} attempts.`);
        return false;
    }

    const handleSortAndAssign = async () => {
        const sortType: 'random' | 'score-roundrobin' = currentEvent?.has_judging ? 'score-roundrobin' : 'random';
        const isMusic: boolean = currentEvent?.event_type_id === 'MUSIC';
        const currentInstrumentId = currentInstrument?.instrument_id;

        const newAssignments = sortAndAssignRegistrants(sortType, isMusic, currentInstrumentId);
        const BATCH_SIZE = 100; // Adjust based on your server's capacity
        const chunks = chunkArray(newAssignments, BATCH_SIZE);

        try {
            for (const chunk of chunks) {
                const success = await retryPostAssignments(chunk);
                if (!success) {
                    console.error('Failed to post one of the batches. Stopping further posts.');
                    break; // Optional: stop if any batch fails
                }
            }

            setAssignments(prev => {
                const updatedIds = new Set(newAssignments.map(a => a.registrant_id));
                return prev.map(a =>
                    updatedIds.has(a.registrant_id)
                        ? newAssignments.find(n => n.registrant_id === a.registrant_id)!
                        : a
                );
            });

        } catch (error) {
            console.error('Error posting assignments:', error);
            // Optionally handle error per batch
        }
    };



    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', gap: '20px', alignItems: 'end', flexWrap: 'wrap', flexDirection: 'row' }}>
                <h1>{`${currentEvent?.event_name} ${currentEvent?.event_type_group_name_plural ?? 'Groups'}`} </h1>
                <h2 style={{}}>{currentGroup ? `Current ${currentEvent?.event_type_group_name}: ${currentGroup.group_name}` : `Select a ${currentEvent?.event_type_group_name}`}</h2>
            </div>
            {/* Group List with Search and Toggle for Deleted Groups */}
            <div style={{ marginBottom: '5px', display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', width: '100%' }}>
                    <input
                        style={{ maxWidth: '400px', width: '90%' }}
                        type="text"
                        placeholder={`Search ${currentEvent?.event_type_group_name_plural}...`}
                        value={groupBandQuery}
                        onChange={e => setGroupBandQuery(e.target.value)}
                    />
                    <button onClick={handleCreateGroup} style={{ maxHeight: '40px', display: 'flex', alignItems: 'center' }} disabled={currentEvent?.is_locked}>Create New {currentEvent?.event_type_group_name} <span style={{ fontSize: '24px' }}>+</span></button>

                </div>
                <div style={{ minWidth: '300px', justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                    <ToggleSwitch label={`Show Deleted ${currentEvent?.event_type_group_name_plural}`} checked={showDeletedGroups} onChange={setShowDeletedGroups} />
                </div>
            </div>
            <div className='card' style={{
                display: 'flex',
                flexWrap: 'wrap', // Allow wrapping of group items to the next line
                gap: '10px',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                backgroundColor: '#161f28'
            }}>
                {filteredGroups.map(group => (
                    <div
                        key={group.event_group_id}
                        className="card"
                        style={{
                            flex: '0 0 auto',
                            padding: '10px',
                            border: currentGroup?.event_group_id === group.event_group_id ? '2px solid green' : '1px solid #ccc',
                            borderRadius: '5px',
                            width: '150px', // Ensures each group takes up at least 200px
                            textAlign: 'center',
                            cursor: 'pointer',
                            position: 'relative',
                            backgroundColor: 'white' // For the marker
                        }}
                        onClick={() => {
                            if (currentGroup?.event_group_id == group.event_group_id) {
                                setCurrentGroup(null)
                            } else {
                                setCurrentGroup(group);
                            }
                        }}

                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => handleDrop(e.dataTransfer.getData('text/plain'), group.event_group_id)}
                    >
                        <h3 style={{ marginBlockStart: '10px', marginBlockEnd: '10px' }}>{group.group_name}<span style={{ color: 'darkred' }}>{group.is_deleted ? ' (Deleted)' : ''}</span></h3>
                        {currentGroup?.event_group_id === group.event_group_id && (
                            <span
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '10px',
                                    fontStyle: 'italic',
                                    color: 'green',
                                }}
                            >
                                Selected
                            </span>
                        )}
                        <p>Level {group.level}</p>
                        {group.event_group_id != 'unassigned' && (<button

                            onClick={(e) => {
                                e.stopPropagation();
                                handleEditGroup(group);
                            }}
                            style={{ padding: '5px 10px' }}
                            disabled={currentEvent?.is_locked}
                        >
                            Edit
                        </button>)}
                    </div>
                ))}
            </div>

            {/* Group Editing Popup */}
            {isEditing && editGroup && (
                <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', minWidth: '400px', maxWidth: '98%', background: 'white', padding: '20px', zIndex: 1000 }}>
                    <h3>{editGroup.event_group_id ? `Edit ${currentEvent?.event_type_group_name}` : `Create ${currentEvent?.event_type_group_name}`}</h3>
                    <div>
                        <label>{currentEvent?.event_type_group_name} Name:</label>
                        <input type="text" value={editGroup.group_name} onChange={(e) => setEditGroup({ ...editGroup, group_name: e.target.value })} />
                    </div>
                    {currentEvent?.event_type_id === 'MUSIC' && (<div>
                        <label>{currentEvent?.event_type_group_name} Level:</label>
                        <input type="number" step={1} min={1} max={groups.length} value={editGroup.level} onChange={(e) => setEditGroup({ ...editGroup, level: parseInt(e.target.value) })} />
                    </div>)}
                    <div className='buttonsRow'>
                        <div className='buttonsLeft'>
                            <button onClick={handleSaveGroup}>Save</button>
                        </div>
                        <div className='buttonsRight'>
                            <button className='warningButton' onClick={handleDeleteGroup}>Delete</button>
                            <button className='cancelButton' onClick={() => setIsEditing(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {isEditing && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 999,
                    }}
                    onClick={() => {
                        setIsEditing(false);
                    }}
                />
            )}

            {/* <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}> */}
            <h1 style={{ marginBlockEnd: '0px' }}>Sort Registrants</h1>

            {/* <button onClick={handleSortAndAssign} 
                // disabled={unsortedAssignments.length > 0}
                 style={{ maxHeight: '50px', marginTop: '10px' }}>Sort</button>
 */}

            {/* </div> */}

            {/* Group Assignment Table */}
            {/* <GroupAssignmentDetailsTable assignments={assignments} group_id={currentGroup?.event_group_id || null} is_music={currentEvent?.event_type_id === 'MUSIC'} /> */}

            <div>
                {/* Search Bar */}
                <div style={{ marginBottom: '10px', flexDirection: 'row', flexWrap: 'wrap', display: 'flex', gap: '10px' }}>
                    <input
                        style={{ maxHeight: '20px', marginTop: '20px' }}
                        type="text"
                        placeholder="Search assignments..."
                        value={searchAssignmentQuery}
                        onChange={(e) => setAssignmentSearchQuery(e.target.value)}
                    />

                    {(instruments && currentEvent?.event_type_id === 'MUSIC') && (<SimpleInstrumentDropdown
                        instruments={instruments}
                        currentInstrument={currentInstrument}
                        setCurrentInstrument={setCurrentInstrument}
                    />)}

                    {/* {(currentInstrument && currentEvent?.event_type_id === 'MUSIC' || currentEvent?.event_type_id != 'MUSIC') && (
                        <div style={{ display: 'flex' }}>
                            <button onClick={handleSortAndAssign} style={{ maxHeight: '50px', marginTop: '10px' }}>{currentEvent?.has_judging ? 'Sort By Score' : 'Randomly Assign'}</button>
                        </div>)} */}
                </div>

                {/* Table */}
                <div className='tableWrapper'>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                {(currentGroup != null && currentGroup.event_group_id != 'unassigned' && (currentEvent?.event_type_id !== 'MUSIC' || currentInstrument != undefined)) && <th>Order</th>}
                                <th
                                    onClick={() => handleSort('first_name')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    First Name
                                    {sortConfig.key === 'first_name' ? (sortConfig.direction === 'desc' ? '↑' : '↓') : ''}
                                </th>
                                <th
                                    onClick={() => handleSort('last_name')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    Last Name
                                    {sortConfig.key === 'last_name' ? (sortConfig.direction === 'desc' ? '↑' : '↓') : ''}
                                </th>
                                {!!currentEvent?.has_judging && <th onClick={() => handleSort('average_score')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >Score
                                    {sortConfig.key === 'average_score' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}

                                </th>}

                                {!!(currentEvent?.event_type_id === 'MUSIC') && (<th
                                    onClick={() => handleSort('instrument')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    Instrument
                                    {sortConfig.key === 'instrument' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>)}
                                <th
                                    onClick={() => handleSort('chair_number')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    { currentEvent?.event_type_id === 'MUSIC' ? `Chair Number` : `Ranking`}
                                    {sortConfig.key === 'chair_number' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>

                                {/* Conditionally render columns based on hideColumns prop */}

                                {/* <th
                                onClick={() => handleSort('group_role')}
                                style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                            >
                                Role */}
                                {/* {sortConfig.key === 'group_role' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''} */}
                                {/* </th> */}

                                {!!currentEvent?.require_organization && <th
                                    onClick={() => handleSort('organization_name')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    Organization
                                    {sortConfig.key === 'organization_name' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>}
                                <th
                                    onClick={() => handleSort('email')}
                                    style={{ cursor: 'pointer', padding: '10px', borderBottom: '1px solid #ccc' }}
                                >
                                    Email
                                    {sortConfig.key === 'email' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                                </th>
                                <th>
                                    Remove
                                </th>
                                <th>
                                    Group Name
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {filteredAssignments.map((assignment) => (
                                <tr key={assignment.registrant_id}>
                                    {(currentGroup != null && currentGroup.event_group_id != 'unassigned' && (currentEvent?.event_type_id !== 'MUSIC' || currentInstrument != undefined)) && <td><div style={{ display: 'flex', gap: '2px' }}><button onClick={() => { moveUp(assignment) }} disabled={assignment.chair_number == 1} style={{ padding: '3px 5px' }}>{'\u25B2'}</button>
                                        <button onClick={() => { moveDown(assignment) }} disabled={assignment.chair_number == filteredAssignments.length} style={{ padding: '3px 5px' }}>{'\u25BC'}</button></div></td>}
                                    <td>{assignment.first_name}</td>
                                    <td>{assignment.last_name}</td>
                                    {!!currentEvent?.has_judging && <td>{assignment.average_score}</td>}
                                    {!!(currentEvent?.event_type_id === 'MUSIC') && (<td>{assignment.instrument_name}</td>)}
                                    <td>{assignment.event_group_id && assignment.event_group_id != 'unassigned' && assignment.event_group_id != '' ? assignment.chair_number : 'Unassigned'}</td>
                                    {/* <td>{assignment.group_role}</td> */}
                                    {!!currentEvent?.require_organization && <td>{assignment.organization_name}</td>}
                                    <td>{assignment.email}</td>
                                    <td style={{ minWidth: '60px' }}>
                                        {/* <div style={{ display: 'flex', gap: '5px' }}> */}
                                        <button className='warningButton' style={{ padding: '5px 15px', maxHeight: '35px' }} disabled={currentEvent?.is_locked || !assignment.event_group_id || assignment.event_group_id == 'unassigned' || assignment.event_group_id == ''} onClick={() => handleSwitchGroups(assignment.registrant_id, 'unassigned')}>Remove</button>
                                    </td>
                                    <td>
                                        <select style={{ padding: '6px' }}
                                            value={assignment.event_group_id ?? 'unassigned'}
                                            onChange={(e) => handleSwitchGroups(assignment.registrant_id, e.target.value)}
                                            disabled={currentEvent?.is_locked}
                                        >
                                            {/* <option key={''} value={''}>
                                                    Unassigned
                                                </option> */}
                                            {groups
                                                .filter(group => !group.is_deleted)
                                                .map(group => (
                                                    <option key={group.event_group_id} value={group.event_group_id}>
                                                        {group.group_name}
                                                    </option>
                                                ))}
                                        </select>
                                        {/* </div> */}

                                    </td>

                                    {/* Conditionally render data based on hideColumns prop */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default GroupDashboard;
